import { App } from './app.class';
import { Notification } from './notification.class';
import { Popup } from './popup.class';
import { Fetch } from '../fetch.class';
import * as Sqrl from 'squirrelly';
import Upgrademodal from './upgrademodal.class';

export class Page {

    constructor() {

        // Vars
        this.current_page = 1;
        this.pages = 1;
        this.count_all = 0;
        this.spinnerSelector = '.tablearea .area-spinner';

        // Template für Tabellenzeilen
        this.tplTablerow = Sqrl.compile( document.getElementById('tpl_tablerow').innerHTML.replace(/=&gt;/g, '=>') );

        // Elemente
        this.$formCode = document.querySelector('header .form_code');
        this.$selectBox = document.getElementById('select_box');
        this.$actionsArea = document.querySelector('.actionsarea');
        this.$controlsAllActions = document.querySelector('.all_actions');
        this.$controlsSelectedActions = document.querySelector('.selected_actions');
        this.$exportAction = document.querySelector('#export-action');
        this.$selectedCounter = document.querySelectorAll('.selected_counter');
        this.$tableEmptyState = document.querySelector('.tablearea .empty-state');
        this.$tableWrapper = document.querySelector('.tablearea .tablewrapper');
        this.$selectAll = this.$tableWrapper.querySelector('thead input[type=checkbox]');
        this.$submissionsCounter = document.querySelector('.sub_counter');
        this.$submissionsStrSingle = document.querySelector('.sub_single');
        this.$submissionsStrPlural = document.querySelector('.sub_plural');
        this.$submissionsStrSpanInbox = document.querySelector('.sub_timespan_inbox');
        this.$submissionsStrSpanOther = document.querySelector('.sub_timespan_other');
        this.$submissionsUpgradeLink = document.querySelector('.sub_upgrade');
        this.$pagination = document.querySelector('nav.pagination');
        this.$paginationBtnBack = this.$pagination.querySelector('button.back');
        this.$paginationBtnNext = this.$pagination.querySelector('button.next');
        this.$paginationDesktop = this.$pagination.querySelector('.desktop');
        this.$paginationMobileSelect = document.getElementById('select_page');

        // Formular-Code
        this.form_code = this.$formCode.textContent;

        // Wechsel von Box
        this.$selectBox.addEventListener('change', event => {
            this.loadList( 1 );
        });

        // Alle Zeilen an-/abwählen
        this.$selectAll.addEventListener('change', event => {
            const checked = event.currentTarget.checked;
            const chkboxs = this.$tableWrapper.querySelectorAll('tbody input[type=checkbox]');
            if(chkboxs.length === 0)
                return;
            chkboxs.forEach(el => {
                el.checked = checked;
            });
            this.updateSelectedActions();
        });

        // Aktionen zu gewählten Zeilen
        let btns = this.$controlsSelectedActions.querySelectorAll('button.action');
        btns.forEach(el => {
            el.addEventListener('click', event => {

                // Liste der gewählten Zeilen
                const selected = this.getSelectedIds();

                // Aktionen
                if(event.currentTarget.classList.contains('isspam')) {
                    this.moveTo('spam', selected);
                }
                else if(event.currentTarget.classList.contains('nospam')) {
                    this.moveTo('inbox', selected);
                }
                else if(event.currentTarget.classList.contains('delete')) {
                    this.moveTo('trash', selected);
                }
                else if(event.currentTarget.classList.contains('undelete')) {
                    this.moveTo('inbox', selected);
                }
                else if(event.currentTarget.classList.contains('deletefinally')) {
                    this.deleteFinally(selected);
                }
            });
        });

        // Events bei Pagination
        this.$paginationBtnBack.addEventListener('click', event => {
            this.loadList( this.current_page-1 );
        });
        this.$paginationBtnNext.addEventListener('click', event => {
            this.loadList( this.current_page+1 );
        });
        this.$paginationMobileSelect.addEventListener('change', event => {
            this.loadList( event.currentTarget.value );
        });

        // Upgrade-Link im Footer
        if(this.$submissionsUpgradeLink) {
            const $btnUpgrade = this.$submissionsUpgradeLink.querySelector('a.upgrade');
            $btnUpgrade.addEventListener('click', event => {
                event.preventDefault();
                const $ele = event.currentTarget;
                const successMsg = $ele.dataset.successmsg ?? '';

                Upgrademodal.open(
                    () => {

                        // Erfolgsmeldung
                        new Notification().success("Upgrade", successMsg);

                        // Liste neu laden
                        this.loadList();

                        // Upgrade-Link aus DOM entfernen
                        this.$submissionsUpgradeLink.remove();
                    },
                    "archive"
                );
            });
        }

        // Liste laden
        this.loadList();
    }

    loadList(page=0) {

        let scrollToTop = false;
        const data = new FormData();
        data.append("form_code", this.form_code);
        if(page > 0) {
            data.append("box", this.$selectBox.value);
            data.append("page", page);
            scrollToTop = true;
        }

        // Ladespinner anzeigen
        App.showSpinnerArea(this.spinnerSelector);

        // Export-Funktion ausblenden wenn nicht Inbox
        if(this.$selectBox.value == 'inbox') {
            this.$exportAction.classList.remove("hidden");
        } else {
            this.$exportAction.classList.add("hidden");
        }

        // Laden
        new Fetch().post(App.getUrl('form', 'submissions_load'), data)
        .then(response => {

            // Daten übernehmen
            this.current_page = parseInt(response.page);
            this.pages = parseInt(response.pages);
            this.count_all = parseInt(response.count_all);

            const allowedBoxes = ['inbox', 'spam', 'trash'];
            if(response?.box === undefined || !allowedBoxes.includes(response.box)) {
                response.box = 'inbox';
            }
            this.$selectBox.value = response.box;

            // Aktionen für ausgewählte Einträge aktualisieren
            this.$controlsSelectedActions.querySelectorAll('button.action').forEach(el => {
                el.classList.add('hidden');
            });
            if(this.$selectBox.value == 'inbox') {
                this.$controlsSelectedActions.querySelectorAll('button.isspam, button.delete').forEach(el => {
                    el.classList.remove('hidden');
                });
                if(this.$submissionsUpgradeLink) {
                    this.$submissionsUpgradeLink.classList.add("show");
                }
            }
            else if(this.$selectBox.value == 'spam') {
                this.$controlsSelectedActions.querySelectorAll('button.nospam').forEach(el => {
                    el.classList.remove('hidden');
                });
                if(this.$submissionsUpgradeLink) {
                    this.$submissionsUpgradeLink.classList.remove("show");
                }
            }
            else if(this.$selectBox.value == 'trash') {
                this.$controlsSelectedActions.querySelectorAll('button.undelete').forEach(el => {
                    el.classList.remove('hidden');
                });
                this.$controlsSelectedActions.querySelectorAll('button.deletefinally').forEach(el => {
                    el.classList.remove('hidden');
                });
                if(this.$submissionsUpgradeLink) {
                    this.$submissionsUpgradeLink.classList.remove("show");
                }
            }

            // Sendungszähler anzeigen
            this.$submissionsCounter.textContent = this.count_all.toLocaleString(App.getLang());
            if(this.count_all == 1) {
                this.$submissionsStrSingle.classList.remove('hidden');
                this.$submissionsStrPlural.classList.add('hidden');
            } else {
                this.$submissionsStrSingle.classList.add('hidden');
                this.$submissionsStrPlural.classList.remove('hidden');
            }

            // Zeitspanne anzeigen
            if(this.$selectBox.value == 'inbox') {
                this.$submissionsStrSpanInbox.classList.remove('hidden');
                this.$submissionsStrSpanOther.classList.add('hidden');
            } else {
                this.$submissionsStrSpanOther.classList.remove('hidden');
                this.$submissionsStrSpanInbox.classList.add('hidden');
            }

            // Pagination rendern
            if(this.current_page == 1)
                this.$paginationBtnBack.setAttribute('disabled', 'true');
            else
                this.$paginationBtnBack.removeAttribute('disabled');

            if(this.current_page == this.pages)
                this.$paginationBtnNext.setAttribute('disabled', 'true');
            else
                this.$paginationBtnNext.removeAttribute('disabled');

            let html = '';
            if(this.current_page > 4) {
                html += '<button type="button" class="page">1</button>';
                html += '<span class="spacing">...</span>';
                html += '<button type="button" class="page">'+(this.current_page-1)+'</button>';
                html += '<button type="button" class="page current">'+this.current_page+'</button>';
            }
            else {
                for(let p=1;p<this.current_page;++p) {
                    html += '<button type="button" class="page">'+p+'</button>';
                }
                html += '<button type="button" class="page current">'+this.current_page+'</button>';
            }
            const rest = this.pages - this.current_page;
            if(rest > 3) {
                html += '<button type="button" class="page">'+(this.current_page+1)+'</button>';
                html += '<span class="spacing">...</span>';
                html += '<button type="button" class="page">'+this.pages+'</button>';
            }
            else {
                for(let p=this.current_page+1;p<=this.pages;++p) {
                    html += '<button type="button" class="page">'+p+'</button>';
                }
            }
            this.$paginationDesktop.innerHTML = html;

            this.$paginationDesktop.querySelectorAll('button.page').forEach(el => {
                el.addEventListener('click', event => {
                    this.loadList( parseInt( event.currentTarget.textContent ) );
                });
            });

            html = '';
            for(let p=1;p<=this.pages;++p) {
                if(p == this.current_page)
                    html += '<option value="'+p+'" selected>'+p+'</option>';
                else
                    html += '<option value="'+p+'">'+p+'</option>';
            }
            this.$paginationMobileSelect.innerHTML = html;

            // keine Sendungen
            if(this.count_all == 0) {
                this.$tableEmptyState.classList.remove('hidden');
                this.$tableWrapper.classList.add('hidden');
                this.$actionsArea.classList.add('hidden');
            }

            // Sendungen vorhanden
            else {

                // Liste rendern
                const $tbody = this.$tableWrapper.querySelector('tbody');
                html = '';
                response.list.forEach(data => {
                    html += this.tplTablerow(data, Sqrl.defaultConfig);
                });
                $tbody.innerHTML = html;

                // Event: Auswahl von Zeile
                $tbody.querySelectorAll('input[type=checkbox]').forEach(el => {
                    el.addEventListener('click', event => {
                        this.updateSelectedActions();
                    });
                });

                // Events: Aktionen
                $tbody.querySelectorAll('button.action').forEach(el => {
                    el.addEventListener('click', event => {

                        // ID der Sendung
                        const $tr = event.currentTarget.closest('tr');
                        const id = parseInt( $tr.getAttribute('data-id') );

                        // Aktionen
                        if(event.currentTarget.classList.contains('isspam')) {
                            this.moveTo('spam', [ id ]);
                        }
                        else if(event.currentTarget.classList.contains('nospam')) {
                            this.moveTo('inbox', [ id ]);
                        }
                        else if(event.currentTarget.classList.contains('delete')) {
                            this.moveTo('trash', [ id ]);
                        }
                        else if(event.currentTarget.classList.contains('undelete')) {
                            this.moveTo('inbox', [ id ]);
                        }
                        else if(event.currentTarget.classList.contains('deletefinally')) {
                            this.deleteFinally([ id ]);
                        }
                    });
                });

                // Aktionen-Popup initialisieren
                const popups = $tbody.querySelectorAll(".popup");
                popups.forEach($ele => {
                    const p = new Popup($ele, instance => {
                        window.Popups.forEach(po => {
                            if(po !== instance) {
                                po.close();
                            }
                        });
                    });
                    window.Popups.push(p);
                });

                // Ein-/Ausblenden
                this.$tableEmptyState.classList.add('hidden');
                this.$tableWrapper.classList.remove('hidden');
                this.$actionsArea.classList.remove('hidden');

                this.$selectAll.checked = false;
                this.updateSelectedActions();

                // nach oben scrollen
                if(scrollToTop) {
                    document.querySelector('main').scrollIntoView({ behavior: 'auto', block: 'start' });
                }
            }
        })
        .catch(error => {

            // Fehlermeldung anzeigen
            new Notification().error('Error during loading!', error.message);
        })
        .finally(() => {

            // Ladespinner ausblenden
            App.hideSpinnerArea(this.spinnerSelector);
        });
    }

    reloadList() {
        this.loadList(this.current_page);
    }

    getSelectedIds() {
        let ids = [];
        this.$tableWrapper.querySelectorAll('tbody input[type=checkbox]:checked').forEach(el => {
            const $tr = el.closest('tr');
            ids.push( parseInt($tr.getAttribute('data-id')) );
        });
        return ids;
    }

    updateSelectedActions() {

        // ausgewählte IDs
        const selected = this.getSelectedIds();
        const count = selected.length;

        // Zähleranzeige
        this.$selectedCounter.forEach(el => {
            el.textContent = count;
        });

        // keine gewählt
        if(count === 0) {
            this.$controlsAllActions.classList.remove('hidden');
            this.$controlsSelectedActions.classList.add('hidden');
        }

        // Zeilen gewählt
        else {
            this.$controlsAllActions.classList.add('hidden');
            this.$controlsSelectedActions.classList.remove('hidden');
        }
    }

    moveTo(toBox, ids) {
        var data = new FormData();
        data.append("form_code", this.form_code);
        data.append("box", toBox);
        data.append("sub_ids", ids.join());

        // Meldungen ausblenden
        new Notification().hideAll();

        // Senden
        new Fetch().post(App.getUrl('form', 'submissions_move'), data)
        .then(response => {

            // Erfolgsmeldung
            new Notification().success(response.msg);

            // Liste neu laden
            this.reloadList();
        })
        .catch(error => {

            // Fehlermeldung anzeigen
            new Notification().error('Error', error.message);
        });
    }

    deleteFinally(ids) {
        var data = new FormData();
        data.append("sub_ids", ids.join());

        // Meldungen ausblenden
        new Notification().hideAll();

        // Senden
        new Fetch().post(App.getUrl('form', 'submissions_deletefinally'), data)
        .then(response => {

            // Erfolgsmeldung
            new Notification().success(response.msg);

            // Liste neu laden
            this.reloadList();
        })
        .catch(error => {

            // Fehlermeldung anzeigen
            new Notification().error('Error', error.message);
        });
    }
}

// Initialisierung wenn DOM geladen
App.domready(() => {
    if(document.querySelector('body').classList.contains('form-submissions')) {
        new Page();
    }
});